import React from 'react';

import { Currency } from '@/constants';
import useReownAccountByCurrency from '@/hooks/useReownAccountByCurrency';

import HeaderWalletDrawerEvmWalletConnect from './HeaderWalletDrawerEvmWalletConnect';
import HeaderWalletDrawerEvmWalletDetails from './HeaderWalletDrawerEvmWalletDetails/HeaderWalletDrawerEvmWalletDetails';

interface HeaderWalletDrawerEvmWalletProps {
  // Add any props you may need here
}

const HeaderWalletDrawerEvmWallet: React.FC<HeaderWalletDrawerEvmWalletProps> = () => {
  const { isConnected } = useReownAccountByCurrency(Currency.ETH);

  if (isConnected) {
    return <HeaderWalletDrawerEvmWalletDetails />;
  }

  return <HeaderWalletDrawerEvmWalletConnect className="h-14 w-full rounded-xl text-base" />;
};

export default HeaderWalletDrawerEvmWallet;
